import { render, staticRenderFns } from "./StandardJob.vue?vue&type=template&id=476de966&scoped=true&"
import script from "./StandardJob.vue?vue&type=script&lang=js&"
export * from "./StandardJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476de966",
  null
  
)

export default component.exports